import { axiosApiInstance } from "../axios";
import type { FinanceDateRangeValue } from "./dates";
import type {
  FinanceCapability,
  FinanceProductionFilters,
  FinanceProductionResponse,
} from "./types";

export async function fetchFinanceAccess(): Promise<FinanceCapability> {
  const response = await axiosApiInstance.get<{ finance: FinanceCapability }>(
    "finance/access",
  );

  return response.data.finance;
}

export async function fetchFinanceProduction(
  range: FinanceDateRangeValue,
  page = 1,
  search = "",
  filters?: FinanceProductionFilters,
): Promise<FinanceProductionResponse> {
  const response = await axiosApiInstance.get<FinanceProductionResponse>(
    "finance/production",
    {
      params: {
        from: range.from,
        to: range.to,
        page,
        search: search || undefined,
        class_ids: filters?.classIds.length ? filters.classIds : undefined,
        category_ids: filters?.categoryIds.length
          ? filters.categoryIds
          : undefined,
        product_ids: filters?.productIds.length
          ? filters.productIds
          : undefined,
        rooms: filters?.rooms.length ? filters.rooms : undefined,
        cost_statuses: filters?.costStatuses.length
          ? filters.costStatuses
          : undefined,
        field_statuses: filters?.fieldStatuses.length
          ? filters.fieldStatuses
          : undefined,
        group_by: filters?.groupBy || "wip",
      },
    },
  );

  return response.data;
}
